var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "share-page",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.closeShare($event)
        }
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("p", [_vm._v("一、点击“ ... ”")]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "share-line" }, [
      _c("img", { attrs: { src: require("./img/line.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\r\n        二、点击“\r\n        "),
      _c("img", { attrs: { src: require("./img/share.jpg") } }),
      _vm._v(" ”分享至朋友圈\r\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "padding-left": "36px" } }, [
      _vm._v("\r\n        点击“\r\n        "),
      _c("img", { attrs: { src: require("./img/send.jpg") } }),
      _vm._v(" ”发给朋友\r\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-528a479e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528a479e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sharePage/index.vue
// module id = null
// module chunks = 